import './App.css';
import Paths from './comps/Paths';

function App() {
  return (
    <div className='App'>
      <Paths></Paths>
    </div>
  );
}

export default App;
